"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialFlowAction = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var social_1 = require("@dp-instant/social");
var utils_1 = require("@dp-instant/utils");
var inversify_1 = require("inversify");
var SocialFlowAction = (function (_super) {
    tslib_1.__extends(SocialFlowAction, _super);
    function SocialFlowAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SocialFlowAction.prototype.execute = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        utils_1.log.debug("#gameflow", this);
                        return [4, this.beforeLaunch()];
                    case 1:
                        _a.sent();
                        return [4, this.launch(data)];
                    case 2:
                        _a.sent();
                        return [4, this.afterLaunch()];
                    case 3:
                        _a.sent();
                        if (process.env.NODE_ENV === "development") {
                            utils_1.log.trace("#gameflow track", this.TRACK_EVENT);
                        }
                        return [2];
                }
            });
        });
    };
    SocialFlowAction.prototype.beforeLaunch = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.showAdIfNeeded()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    SocialFlowAction.prototype.afterLaunch = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.TRACK_EVENT) {
                    this.track();
                }
                return [2];
            });
        });
    };
    SocialFlowAction.prototype.showAdIfNeeded = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.needToShowAD()) return [3, 2];
                        return [4, this.showAd()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    SocialFlowAction.prototype.sendPush = function (actionKey, actionPayload) {
        this.sendPushAsync(actionKey, actionPayload).then();
    };
    SocialFlowAction.prototype.sendPushAsync = function (actionKey, actionPayload) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, ((_a = (0, core_1.lazyGet)(actionKey)) === null || _a === void 0 ? void 0 : _a.run(actionPayload))];
                    case 1:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    SocialFlowAction.prototype.showAd = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.adAction.run()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    SocialFlowAction.prototype.needToShowAD = function () {
        return true;
    };
    SocialFlowAction.prototype.tryToShowBanner = function () {
        var _a, _b;
        if (this.gameConfig.useBannerAd) {
            (_b = (_a = this.adManager).showBanner) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    };
    SocialFlowAction.prototype.track = function () {
        var _a;
        (_a = (0, core_1.lazyGet)(interfaces_1.TypesAnalytics.tracker)) === null || _a === void 0 ? void 0 : _a.track("".concat(this.social.session.ftue ? "ftue_" : "").concat(this.TRACK_EVENT));
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.model),
        tslib_1.__metadata("design:type", Object)
    ], SocialFlowAction.prototype, "social", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesAds.adAction),
        tslib_1.__metadata("design:type", social_1.AdAction)
    ], SocialFlowAction.prototype, "adAction", void 0);
    tslib_1.__decorate([
        (0, core_1.lazyInject)(interfaces_1.TypesCore.gameConfig),
        tslib_1.__metadata("design:type", Object)
    ], SocialFlowAction.prototype, "gameConfig", void 0);
    tslib_1.__decorate([
        (0, core_1.lazyInject)(interfaces_1.TypesAds.manager),
        tslib_1.__metadata("design:type", Object)
    ], SocialFlowAction.prototype, "adManager", void 0);
    SocialFlowAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], SocialFlowAction);
    return SocialFlowAction;
}(core_1.Action));
exports.SocialFlowAction = SocialFlowAction;
//# sourceMappingURL=SocialFlowAction.js.map